import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { addVariationMasterApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const addVariationMaster = createAsyncThunk('addVariationMaster', async (payload) => {
  return await addVariationMasterApi(payload);
});

const addVariationMasterSlice = createSlice({
  name: 'addVariationMaster', // Unique Name
  initialState,
  reducers: {
    addVariationMasterReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(addVariationMaster.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(addVariationMaster.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(addVariationMaster.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { addVariationMasterReset } = addVariationMasterSlice.actions;

export default addVariationMasterSlice.reducer;
